import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FileUploadStatus } from "store/useFileUploadStore";

interface Props {
  taskCode: string | null;
  isUploadInProgress: boolean;
  fileStatuses: FileUploadStatus[];
}

const UploadPopoverTitle = ({ fileStatuses, taskCode, isUploadInProgress }: Props) => {
  const { t } = useTranslation();
  const resultTitle = useMemo(() => {
    const filesByStatus = new Map<string, FileUploadStatus[]>();
    for (const file of fileStatuses) {
      if (!filesByStatus.has(file.status)) {
        filesByStatus.set(file.status, []);
      }
      filesByStatus.get(file.status)!.push(file);
    }
    const uploaded = filesByStatus.get("uploaded") || [];
    const failed = filesByStatus.get("failed") || [];
    const canceled = filesByStatus.get("canceled") || [];
    return [
      uploaded.length > 0
        ? t("task.upload.popover.title.uploaded", { count: uploaded.length })
        : t("task.upload.popover.title.uploaded-none"),
      failed.length > 0 && t("task.upload.popover.title.failed", { count: failed.length }),
      canceled.length > 0 && t("task.upload.popover.title.canceled", { count: canceled.length }),
    ]
      .filter(Boolean)
      .join(", ");
  }, [fileStatuses, t]);

  return (
    <div className="flex flex-1 flex-col items-start" data-test="upload-header">
      <div className="flex w-full">
        <span className="text-color-primary text-base font-medium" data-test="upload-header-title">
          {isUploadInProgress ? t("task.upload.popover.title.uploading", { count: fileStatuses.length }) : resultTitle}
        </span>
      </div>
      {taskCode && (
        <span className="text-color-secondary text-xs" data-test="upload-header-taskcode">
          {t("task.fields.task")}: {taskCode}
        </span>
      )}
    </div>
  );
};

export default UploadPopoverTitle;
